<mat-list>
    <a mat-list-item routerLink="/plants" routerLinkActive="active"> Plants </a>
    <a mat-list-item routerLink="/lines" routerLinkActive="active"> Lines </a>
    <a mat-list-item routerLink="/sublines" routerLinkActive="active"> Sublines </a>
    <a mat-list-item routerLink="/equipment" routerLinkActive="active"> Equipment </a>
    <a mat-list-item routerLink="/subassemblydelta" routerLinkActive="active"> User Defined </a>
</mat-list>